export default class ConfirmClick {
    #element;

    constructor(element) {
        this.#element = element;

        this.#bindEvents();
    }

    static initAll(selector) {
        Array.from(document.querySelectorAll(selector), (element) => new ConfirmClick(element));
    }

    #bindEvents() {
        this.#element.addEventListener('click', this.#handleClick);
    }

    #handleClick = async (event) => {
        event.preventDefault();

        window.confirmClick(this.#element);
    };
}
